import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();

export default (initialState) => {
    const middleware = [sagaMiddleware];
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

    var sagaTask = sagaMiddleware.run(rootSaga);
    sagaTask.toPromise().catch((error) => {
        // Error here is a fatal error.
        // None of the sagas down the road caught it.
    });

    return store;
};
